"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaCampaignForAdminEntity = void 0;
class MediaCampaignForAdminEntity {
    id;
    reqId;
    display;
    playlists;
    campaigns;
    title;
    media;
    owner;
    retentionId;
    price;
    statistics;
    paymentLink;
    dates;
    /**
     * @deprecated
     */
    accepted;
    mediaDuration;
    isExpired;
    status;
    reason;
    metadata;
    isPaid;
    deliveryPolicy;
    deliverySettlement;
    removed;
    updatedAt;
    createdAt;
}
exports.MediaCampaignForAdminEntity = MediaCampaignForAdminEntity;
